export default "__VITE_ASSET__4f3eca27__"